import { api } from "./client";

export type RewardItem = {
  id: string;
  kind: "premium_days" | "partner_voucher";
  title: string;
  description: string | null;
  cost_points: number;
  sort_order: number;
  metadata: Record<string, unknown>;
};

export type RewardsPayload = {
  balance: number;
  items: RewardItem[];
};

export async function getRewards(): Promise<RewardsPayload> {
  return api<RewardsPayload>("/api/rewards");
}

export type RedeemResult = {
  ok: true;
  new_balance: number;
  premium_until: string | null;
};

export async function redeemReward(rewardId: string): Promise<RedeemResult> {
  return api<RedeemResult>("/api/rewards/redeem", {
    method: "POST",
    body: JSON.stringify({ reward_id: rewardId }),
  });
}
